import icon from "../../assets/volume-on.svg";
import type { Property } from "../../types";

export const proAvSupport: Property = {
  id: "proAvSupport",
  title: "proAvSupport.title",
  icon,
  tooltip: "proAvSupport.tooltip",
};
